export default __webpack_public_path__ + "static/media/location--2.74f1479d.jpg";